import { Utensils } from 'lucide-react'
import { cn } from '@/utils'

export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={cn('grid h-10 w-10 place-items-center rounded-xl bg-forest-800 text-saffron-300 shadow-sm', className)} aria-hidden="true">
      <Utensils className="h-5 w-5" />
    </span>
  )
}

export function Brand({ name = 'Buen Plato', subtitle, logoUrl, inverse = false, className }: { name?: string; subtitle?: string; logoUrl?: string | null; inverse?: boolean; className?: string }) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      {logoUrl ? <img src={logoUrl} alt="" className={cn('h-10 w-10 rounded-xl bg-white object-contain p-1 shadow-sm', inverse && 'ring-1 ring-white/20')} /> : <BrandMark className={inverse ? 'bg-white/10 text-saffron-300 ring-1 ring-white/15' : undefined} />}
      <div className="min-w-0">
        <p className={cn('font-display text-lg font-extrabold leading-tight tracking-tight', inverse ? 'text-white' : 'text-forest-900')}>{name}</p>
        {subtitle && <p className={cn('truncate text-xs font-medium', inverse ? 'text-forest-200' : 'text-slate-500')}>{subtitle}</p>}
      </div>
    </div>
  )
}
